<template>
  <pt-label-manage class="pt-label-manage__page"></pt-label-manage>
</template>

<script>
import PtLabelManage from 'cps/mall-manage/recommend-manage/pt-label-manage/withData'
export default {
  name: 'pt-label-manage__view',
  components: {
    'pt-label-manage': PtLabelManage
  }
}
</script>
